import { useMemo, useState } from 'react';
import { IncidentDetail, ReactSimpleComponentProps } from '@/custom-types';
import { IncidentDetailContext, IncidentDetailContextProps } from './IncidentDetailContext';

export const IncidentDetailContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [state, setState] = useState<IncidentDetail | undefined>(undefined)

  const [files, setFiles] = useState<File[]>([])

  const actions = useMemo<Omit<IncidentDetailContextProps, 'incident' | 'downloadedImages'>>(() => ({
    setIncident: (incident: IncidentDetail | undefined) => setState(incident),

    setDownloadedImages: (images: File[]) => setFiles(images),
  }), [])

  return (
    <IncidentDetailContext.Provider value={{ ...actions, incident: state, downloadedImages: files }}>
      {children}
    </IncidentDetailContext.Provider>
  )
}